import React, { useEffect, useState } from 'react';
import './ContactMe.css';
import profilePic from '../images/vinayak.jpeg';
import { FaEnvelope, FaPhoneAlt, FaCoffee, FaLinkedin, FaGithub } from 'react-icons/fa';
import { ContactMe as IContactMe } from '../types';
import { getContactMe } from '../queries/getContactMe';

// Fallback data for contact information
const FALLBACK_CONTACT_DATA: IContactMe = {
  profilePicture: { url: "" },
  name: "Vinayak Singh",
  title: "AI & Full Stack Innovator",
  summary: "Building Products that Think, Learn & Scale. I design and deploy intelligent web systems — blending AI, automation, and full-stack development to turn bold ideas into reality.",
  companyUniversity: "Tech Innovator",
  linkedinLink: "https://www.linkedin.com/in/vinayak-singh-147047238/",
  email: "singhvinayak110@gmail.com",
  phoneNumber: "+91 9967074374"
};

const ContactMe: React.FC = () => {
  const [userData, setUserData] = useState<IContactMe | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchUserData() {
      try {
        const data = await getContactMe();
        setUserData(data);
      } catch (err) {
        console.error("Failed to fetch contact data:", err);
        setError("Failed to load contact data. Showing sample content.");
        // Use fallback data when API request fails
        setUserData(FALLBACK_CONTACT_DATA);
      } finally {
        setLoading(false);
      }
    }

    fetchUserData();
  }, []);

  if (loading) return <div className="contact-loading">Loading contact information...</div>;
  
  if (error) {
    console.warn(error);
  }

  // If we still don't have data for some reason, use fallback
  const displayData = userData || FALLBACK_CONTACT_DATA;

  return (
    <div className="contact-container">
      <div className="linkedin-badge-custom">
        <img src={profilePic} alt="Vinayak Singh" className="badge-avatar" />
        <div className="badge-content">
          <h3 className="badge-name">{displayData.name}</h3>
          <p className="badge-title">{displayData.title}</p>
          <p className="badge-description">
            {displayData.summary}
          </p>
          <p className="badge-company">{displayData.companyUniversity}</p>
          <a
            href={displayData.linkedinLink}
            target="_blank"
            rel="noopener noreferrer"
            className="badge-link"
          >
            <FaLinkedin className="linkedin-icon" /> View Profile
          </a>
        </div>
      </div>
      <div className="contact-header">
        <p>I'm always up for a chat or a coffee! Feel free to reach out.</p>
      </div>
      <div className="contact-details">
        <div className="contact-item">
          <FaEnvelope className="contact-icon" />
          <a href={`mailto:${displayData.email}`} className="contact-link">
            {displayData.email}
          </a>
        </div>
        <div className="contact-item">
          <FaPhoneAlt className="contact-icon" />
          <a href={`tel:${displayData.phoneNumber}`} className="contact-link">
            {displayData.phoneNumber}
          </a>
        </div>
        <div className="contact-item">
          <FaGithub className="contact-icon github-icon" />
          <a href="https://github.com/Vink-135" target="_blank" rel="noopener noreferrer" className="contact-link">
            GitHub Profile
          </a>
        </div>
        <div className="contact-fun">
          <p>Or catch up over a coffee ☕</p>
          <FaCoffee className="coffee-icon" />
        </div>
      </div>
    </div>
  );
};

export default ContactMe;